/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meta_Privacy_TitleInputs */

const en_meta_privacy_title = /** @type {(inputs: Meta_Privacy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privacy Policy | Lindevo`)
};

const lv_meta_privacy_title = /** @type {(inputs: Meta_Privacy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privātuma politika | Lindevo`)
};

/**
* | output |
* | --- |
* | "Privacy Policy \| Lindevo" |
*
* @param {Meta_Privacy_TitleInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const meta_privacy_title = /** @type {((inputs?: Meta_Privacy_TitleInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meta_Privacy_TitleInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_meta_privacy_title(inputs)
	return en_meta_privacy_title(inputs)
});